export const COMPONENT_CLASS = 'component_class',
  IC_CLASS = 'ic_class',
  DRIVER_CLASS = 'driver_class',
  ROOT_CLASS = 'root_class',
  CONN_CLASS = 'connection_class'